import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {DocumentModel} from '../../models/document.model';
import {AlertController, LoadingController, ModalController} from '@ionic/angular';
import {EquipListReturnScaffoldingPage} from '../../modals/scaffolding/equip-list-return-scaffolding/equip-list-return-scaffolding.page';
import {LokijsService} from '../../services/database/lokijs.service';
import {CustomerResourceService} from '../../services/database/resource/customer-resource.service';
import {GeneralService} from '../../services/general.service';
import {Subscription} from 'rxjs';
import {ReturnScaffoldingPage} from '../../modals/scaffolding/return-scaffolding/return-scaffolding.page';

@Component({
    selector: 'items-return-scaffolding',
    templateUrl: './items-return-scaffolding.component.html',
    styleUrls: ['./items-return-scaffolding.component.scss'],
})
export class ItemsReturnScaffoldingComponent implements OnInit {

    @Input() document: DocumentModel;
    detailLinesList: DetaillineDTOModel[];
    groupedDetailLines = [];
    currentGroupedItems = [];
    currentGroupedItemsSubs: Subscription;
    loading: any;

    constructor(private modalController: ModalController,
                private alertController: AlertController,
                private loki: LokijsService,
                private customerRes: CustomerResourceService,
                private loadingController: LoadingController,
                private generalService: GeneralService,
                private returnScaffoldingPage: ReturnScaffoldingPage) {
    }

    async ngOnInit() {
        console.log('Items Return Scaffolding ngOnInit');
        if (this.document.detailLines.length > 0) {
            await this.loadingFetchingDetailLines();
            this.populateCurrentGroupedItems();
            console.log('Populate Current Grouped Items');
        }
        this.currentGroupedItemsSubs = this.returnScaffoldingPage.groupedItemsObs.subscribe(res => {
            this.currentGroupedItems = res;
        });
    }

    async loadingFetchingDetailLines() {
        this.groupedDetailLines = [];
        this.currentGroupedItems = [];
        this.loadingController.create({
            message: 'Please wait...',
            translucent: true,
            cssClass: 'custom-class custom-loading'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
        await this.fetchContracts()
            .then(() => {
                this.loading.dismiss();
            }).catch(err => {
                console.log(err);
            });
    }

    async fetchContracts() {
        let contracts: any;
        if (this.document.documentNumber !== 0) {
            contracts = await this.loki.getCollection('return').chain().data();
        } else {
            // contracts = await this.loki.getCollection('livecontract').chain().data();
            // contracts = contracts.filter(elem => {
            //     return elem.customer.cod === this.document.customer.cod;
            // });
            contracts = await this.customerRes.getContracts(this.document.customer.id) as DocumentModel[];
        }

        if (this.document.site.id) {
            const tempContracts = JSON.parse(JSON.stringify(contracts));
            contracts = tempContracts.filter(elem => {
                return elem.site.id === this.document.site.id;
            });
        }

        if (contracts.length > 0) {
            this.detailLinesService(contracts);
        }
    }

    async detailLinesService(contracts: DocumentModel[]) {
        console.log(contracts);
        this.detailLinesList = new Array<DetaillineDTOModel>();
        for (const contract of contracts) {
            if (contract.detailLines.length > 0) {
                for (const line of contract.detailLines) {
                    line.siteId = contract.site.id;
                    this.detailLinesList.push(line);
                }
            }
        }
        this.detailLinesList.sort((a, b) => (a.contractDocumentNumber < b.contractDocumentNumber) ? 1 : -1);
        this.groupDetailLines();
    }

    groupDetailLines() {
        for (const line of this.detailLinesList) {
            if (line.pdesc) {
                const tempLine = new DetaillineDTOModel();
                tempLine.pdesc = line.pdesc;
                tempLine.description = line.description;
                tempLine.qty = line.qty;
                tempLine.siteId = line.siteId;
                const index = this.indexOfGroupedLine(tempLine, this.groupedDetailLines);
                if (index < 0) {
                    this.groupedDetailLines.push({line: tempLine, isChecked: false});
                } else {
                    this.groupedDetailLines[index].line.qty += tempLine.qty;
                }
            }
        }
        for (const line of this.groupedDetailLines) {
            line.line.maxReturnQty = line.line.qty;
        }
        console.log(this.groupedDetailLines);
    }

    async eqListModal() {
        await this.loadingFetchingDetailLines();
        const modal = await this.modalController.create({
            component: EquipListReturnScaffoldingPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': this.document,
                'groupedDetailLines': this.groupedDetailLines,
                'currentGroupedItems': this.currentGroupedItems
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.currentGroupedItems = dataReturned.data;
                this.updateDetailLinesInDocument(this.currentGroupedItems);
            }
        });

        return await modal.present();
    }

    indexOfLine(line: DetaillineDTOModel, lineList: DetaillineDTOModel[]) {
        for (let i = 0; i < lineList.length; i++) {
            if (lineList[i].pdesc === line.pdesc) {
                return i;
            }
        }
        return -1;
    }

    indexOfGroupedLine(line: DetaillineDTOModel, lineList: DetaillineDTOModel[]) {
        for (let i = 0; i < lineList.length; i++) {
            if (lineList[i].line.pdesc === line.pdesc) {
                return i;
            }
        }
        return -1;
    }

    async updateDetailLinesInDocument(detailLines: DetaillineDTOModel[]) {
        for (const dtLine of detailLines) {
            this.removePdescFromDetailLines(dtLine);
        }
        console.log('Before inserting dtLines: ', this.document.detailLines);
        for (const line of this.currentGroupedItems) {
            this.fulfillContractLines(line);
        }
    }

    fulfillContractLines(line: DetaillineDTOModel) {
        let tempQty = line.qty;
        if (tempQty <= 0) {
            this.groupedDetailLines.splice(this.groupedDetailLines.indexOf(line, 1));
            return;
        }
        for (const dtLine of this.detailLinesList) {
            if (dtLine.pdesc === line.pdesc) {
                delete dtLine.maxReturnQty;
                delete dtLine.siteId;
                const tempDetailLine = JSON.parse(JSON.stringify(dtLine)) as DetaillineDTOModel;
                tempDetailLine.documentNumber = dtLine.contractDocumentNumber;
                tempDetailLine.detailLineId = 0;
                tempDetailLine.typ = dtLine.typ;
                tempDetailLine.qty = tempQty <= dtLine.qty ? tempQty : dtLine.qty;
                this.document.detailLines.push(tempDetailLine);
                tempQty -= dtLine.qty;
                if (tempQty <= 0) {
                    break;
                }
            }
        }
    }

    async checkQty(event: CustomEvent, item: any) {
        if (event.detail.value > item.maxReturnQty) {
            item.qty = item.maxReturnQty;
            this.generalService.createToast('Invalid Qty! Max Qty: ' + item.maxReturnQty);
        }
        if ((item.qty <= item.maxReturnQty) && (item.qty > 0)) {
            this.removePdescFromDetailLines(item);
            this.fulfillContractLines(item);
        }
    }

    populateCurrentGroupedItems() {
        for (const line of this.document.detailLines) {
            for (const groupLine of this.groupedDetailLines) {
                if (line.pdesc === groupLine.line.pdesc) {
                    const index = this.indexOfLine(groupLine.line, this.currentGroupedItems);
                    if (index >= 0) {
                        this.currentGroupedItems[index].qty += line.qty;
                    } else {
                        const tempLine = new DetaillineDTOModel();
                        tempLine.pdesc = line.pdesc;
                        tempLine.description = line.description;
                        tempLine.qty = line.qty;
                        tempLine.maxReturnQty = groupLine.line.maxReturnQty;
                        this.currentGroupedItems.push(line);
                    }
                }
            }
        }
    }

    removeItem(item: any, i: number) {
        item.qty = 0;
        const copyItem = JSON.parse(JSON.stringify(item)) as DetaillineDTOModel;
        console.log(copyItem);
        this.removePdescFromDetailLines(copyItem);
        this.checkGroupedItems(copyItem);
        this.currentGroupedItems.splice(i, 1);
    }

    removePdescFromDetailLines(dtLine: DetaillineDTOModel) {
        const dtLinesCopy = JSON.parse(JSON.stringify(this.document.detailLines));
        this.document.detailLines = dtLinesCopy.filter(elem => {
            return elem.pdesc !== dtLine.pdesc;
        });
    }

    checkGroupedItems(item: DetaillineDTOModel) {
        for (const groupedItem of this.groupedDetailLines) {
            if (item.pdesc === groupedItem.line.pdesc) {
                groupedItem.isChecked = false;
                groupedItem.line.qty = item.maxReturnQty;
            }
        }
    }
}
